import { AnchorWithLink } from 'atoms/Anchor';
import ModalComponent from 'molecules/Modal';
import React, { useState } from 'react';
import { ButtonComp } from 'atoms/Buttons';
import { MaterialTextInput } from 'atoms/MaterialInput';
import { useDispatch, useSelector } from 'react-redux';
import { updateCustomerInfo } from '@kfc-global/react-shared/redux/Actions/OrderservAction';
import { formatPhoneNumber } from 'common/utilities/utils';
import { ACCOUNT_SETTINGS } from '../Constants/Constants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { editPersonalInformationAnalytics } from '../accountPageUtils';
import {
  isValidAccountForm,
  validateEmail,
  validateFullName,
  validatePhone,
} from 'organisms/ContactUs/Utils/contactUsUtils';

const EditAccountInformationModal = ({ handleClose, customerData, updateCustomerData, isLoading }) => {
  const {
    EDIT_PERSONAL_INFO,
    emailHelpText,
    phoneHelpText,
    firstNameHelpText,
    lastNameHelpText,
    SAVE,
    CANCEL,
    FIRST_NAME_TEXT,
    LAST_NAME_TEXT,
    EMAIL_TEXT,
    PHONE_NUMBER_TEXT,
  } = ACCOUNT_SETTINGS;

  const [customerInfo, setCustomerInfo] = useState({
    firstName: customerData?.firstName,
    lastName: customerData?.lastName,
    emailId: customerData?.email,
    phoneNumber: customerData?.phone,
  });

  const onChangeForm = e => {
    if (e.target.name === 'phoneNumber' && e.target.value.length > 10) {
      return;
    }
    setCustomerInfo({ ...customerInfo, [e.target.name]: e.target.value });
  };

  return (
    <React.Fragment>
      <ModalComponent
        classNames='personal-information-modal'
        id='alertPop'
        role='dialog'
        show={true}
        closeDataTestId='handler-close'
        autoFocus={true}
        showCloseBtn={true}
        closeButtonHandler={handleClose}
        modalTitleRequired={true}
        modalTitle={translateWithI18Next(EDIT_PERSONAL_INFO)}
      >
        <div className='personal-information-card'>
          <p className='personal-information-text'>{'PERSONAL INFORMATION'}</p>
          <MaterialTextInput
            name={'firstName'}
            placeholder={translateWithI18Next(FIRST_NAME_TEXT)}
            value={customerInfo?.firstName}
            inputClassName='edit-info-input-class'
            onChange={onChangeForm}
            error={customerInfo?.firstName?.length > 0 && !validateFullName(customerInfo?.firstName)}
            helperText={translateWithI18Next(firstNameHelpText)}
            helperTextClassName='error-text'
            maxlength='20'
          />
          <MaterialTextInput
            name={'lastName'}
            placeholder={translateWithI18Next(LAST_NAME_TEXT)}
            value={customerInfo?.lastName}
            inputClassName='edit-info-input-class'
            onChange={onChangeForm}
            error={customerInfo?.lastName?.length > 0 && !validateFullName(customerInfo?.lastName)}
            helperText={translateWithI18Next(lastNameHelpText)}
            helperTextClassName='error-text'
            maxlength='20'
          />
          <MaterialTextInput
            name={'emailId'}
            type='email'
            placeholder={translateWithI18Next(EMAIL_TEXT)}
            value={customerInfo?.emailId}
            inputClassName='edit-info-input-class'
            onChange={onChangeForm}
            error={customerInfo?.emailId?.length > 0 && !validateEmail(customerInfo.emailId)}
            helperText={translateWithI18Next(emailHelpText)}
            helperTextClassName='error-text'
            maxlength='320'
          />
          <MaterialTextInput
            readOnly={customerData?.phone?.length > 0}
            name={'phoneNumber'}
            data-testid='phone-number-testid'
            placeholder={translateWithI18Next(PHONE_NUMBER_TEXT)}
            value={customerInfo?.phoneNumber}
            inputClassName='edit-info-input-class'
            onChange={onChangeForm}
            error={customerInfo?.phoneNumber?.length > 0 && !validatePhone(customerInfo?.phoneNumber)}
            helperText={translateWithI18Next(phoneHelpText)}
            helperTextClassName='error-text'
          />
          <div className='buttons-container'>
            <ButtonComp className='buttons-group cancel' onClickHandler={handleClose}>
              {translateWithI18Next(CANCEL)}
            </ButtonComp>
            <ButtonComp
              className='buttons-group save'
              disabled={
                isLoading ||
                !isValidAccountForm({
                  firstNameText: customerInfo.firstName,
                  lastNameText: customerInfo.lastName,
                  phoneNoText: customerInfo.phoneNumber,
                  emailText: customerInfo.emailId,
                })
              }
              data-testid='update-account-button-testid'
              onClickHandler={() => updateCustomerData(customerInfo)}
            >
              {translateWithI18Next(SAVE)}
            </ButtonComp>
          </div>
        </div>
      </ModalComponent>
    </React.Fragment>
  );
};

const PersonalInfoCard = ({ basicData, isLoading }) => {
  const { PERSONAL_INFO_TEXT, EDIT } = ACCOUNT_SETTINGS;
  const [editDialog, setEditDialog] = useState(false);
  const tenantReducer = useSelector(data => data.tenantReducer);
  const customerId = useSelector(data => data.profileReducer.customerId);

  const editInformationDialog = () => {
    setEditDialog(true);
  };
  const dispatch = useDispatch();

  const updateCustomerData = customerInfo => {
    // analytics for saving preferences
    editPersonalInformationAnalytics(
      customerInfo,
      tenantReducer?.componentOptions?.phoneNumberConstants?.phoneRegexPattern,
    );
    dispatch(
      updateCustomerInfo({
        tenantId: tenantReducer?.tenantId,
        customerId,
        body: customerInfo,
      }),
    );
    setEditDialog(false);
  };

  return (
    <div className='personal-info-card'>
      <div className='personal-card-left-side'>{translateWithI18Next(PERSONAL_INFO_TEXT)}</div>
      <div className='personal-card-right-side'>
        <div className='edit-input'>
          <AnchorWithLink data-testid='edit-account-button-testid' onClickHandler={editInformationDialog}>
            {translateWithI18Next(EDIT)}
          </AnchorWithLink>
        </div>
        <p>
          {basicData?.firstName} {basicData?.lastName}
        </p>
        <p>{basicData.email}</p>
        <p>{formatPhoneNumber(basicData?.phone)}</p>
      </div>
      {editDialog && (
        <EditAccountInformationModal
          handleClose={() => {
            setEditDialog(false);
          }}
          isLoading={isLoading}
          customerData={basicData}
          updateCustomerData={updateCustomerData}
        />
      )}
    </div>
  );
};
export default PersonalInfoCard;
